module.exports = __webpack_public_path__ + "img/home-bg.11a9c4d5.jpg";